// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d90eedc5","455":"e3201b05","977":"6e421d3c"}[chunkId] + ".chunk.js";
};